/**
 * https://www.npmjs.com/package/@vimeo/player
 */
import Player from '@vimeo/player';

const videoControls = document.querySelectorAll('.video__control.btn--video__play', '.video__control.btn--video__pause');

let toggleVideoState = (player, button, parent) => {
    player.getPaused().then(isPaused => {
        if (isPaused) {
            player.play();
            parent.classList.add('is--playing');
            parent.classList.remove('is--paused');
            button.classList.remove('btn--video__play');
            button.classList.add('btn--video__pause');
        } else {
            player.pause();
            parent.classList.remove('is--playing');
            parent.classList.add('is--paused');
            button.classList.remove('btn--video__pause');
            button.classList.add('btn--video__play');
        }
    }).catch(error => {
        console.error('Error checking player status:', error);
    });
}

if (videoControls.length > 0) {
    videoControls.forEach(button => {
        button.addEventListener('click', event => {
            const parent = event.target.parentNode.parentNode;
            const iframe = parent.querySelector('iframe');
            const player = new Player(iframe);
            
            toggleVideoState(player, button, parent);
        });
    });
}
